let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3hxY1")).then(() => parcelRequire('dKrlX'));